import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import CameraIcon from '@material-ui/icons/PhotoCamera';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Link from '@material-ui/core/Link';
import Carousel from '../components/carousel'

//cements
import Ultratech from '../images/cements_ultratech.jfif';
import India from '../images/cements_india_cements.jfif';
import Chettinad from '../images/cements_chettinad.jfif';
import UltraGold from '../images/cements_ultragold.jfif';

//
import Asian from '../images/paints_asian.jfif';
import Agsar from '../images/paints_agsar.jpg';

//
import Finolex from '../images/pipes_finolex.jfif';
import TaTA from '../images/pipes_tata.jpeg';
import Prince from '../images/pipes_prince.jpg';

//LT
import LT from '../images/electricals_lt.png';
import Fybros from '../images/electricals_fybros.png';
import Orient from '../images/electricals_orient.jpg';

//
import Appa from '../images/appa.jpg'
import Ram from '../images/ram.jpg'
import Raja from '../images/raja.jpg'
import Kumar from '../images/kumar.jpg'

//bnner
import Banner from '../images/preview1.jpg'


const useStyles = makeStyles((theme) => ({
  icon: {
    marginRight: theme.spacing(2),
  },
  heroContent: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(8, 0, 6),
  },
  heroButtons: {
    marginTop: theme.spacing(4),
  },
  cardGrid: {
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(8),
  },
  card: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  cardMedia: {
    paddingTop: '56.25%', // 16:9
  },
  cardContent: {
    flexGrow: 1,
  },
  footer: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(6),
  },
}));

const cards = [1, 2, 3, 4, 5, 6, 7, 8, 9];

export default function Album() {
  const classes = useStyles();

  return (
    <React.Fragment>
      <div className="w3-top">
        <div className="w3-bar w3-white w3-wide w3-padding w3-card">
          <a href="#home" className="w3-bar-item w3-button"><b>SRI MURUGAN</b> Hardwares</a>

          <div className="w3-right w3-hide-small">
            <a href="#projects" class="w3-bar-item w3-button">Products</a>
            <a href="#about" class="w3-bar-item w3-button">About</a>
            <a href="#contact" class="w3-bar-item w3-button">Contact</a>
          </div>
        </div>
      </div>

      <header className="w3-display-container w3-content w3-wide" style={{ maxWidth: '1500px' }} id="home">
        <img className="w3-image" src={Banner} alt="Architecture" width="1500" />
        {/* <div className="w3-display-middle w3-margin-top w3-center">
          <h1 className="w3-xxlarge w3-text-white"><span className="w3-padding w3-black w3-opacity-min"><b>SRI MURUGAN</b></span> <span className="w3-hide-small w3-text-light-grey">Hardwares</span></h1>
        </div> */}
      </header>

      <div className="w3-content w3-padding" style={{ maxWidth: '1564px' }}>

        <div className="w3-container w3-padding-32" id="">
          <h3 className="w3-border-bottom w3-border-light-grey w3-padding-16">Products</h3>
        </div>

        <div className="w3-row-padding">

          <div className="w3-col l3 m6 w3-margin-bottom">
            <div className="w3-display-container">
              <div className="w3-display-topleft w3-black w3-padding zindex-title">Cements</div>
              <Carousel
                items={[
                  { name: '', img: India },
                  { name: '', img: Chettinad },
                  { name: '', img: UltraGold },
                  { name: '', img: Ultratech },
                ]}
              />
            </div>
          </div>

          <div className="w3-col l3 m6 w3-margin-bottom">
            <div className="w3-display-container">
              <div className="w3-display-topleft w3-black w3-padding zindex-title">Paints</div>
              <Carousel
                items={[
                  { name: '', img: Asian },
                  { name: '', img: Agsar },
                ]}
              />
            </div>
          </div>

          <div className="w3-col l3 m6 w3-margin-bottom">
            <div className="w3-display-container">
              <div className="w3-display-topleft w3-black w3-padding zindex-title">Electricals</div>
              <Carousel
                items={[
                  { name: '', img: Fybros },
                  { name: '', img: Orient },
                  { name: '', img: LT },
                ]}
              />
            </div>
          </div>

          <div className="w3-col l3 m6 w3-margin-bottom">
            <div className="w3-display-container">
              <div className="w3-display-topleft w3-black w3-padding zindex-title">Pipes</div>
              <Carousel
                items={[
                  { name: '', img: Finolex },
                  { name: '', img: TaTA },
                  { name: '', img: Prince },
                ]}
              />
            </div>
          </div>


        </div>

      </div>

      <div className="w3-container w3-padding-32" id="about">
        <h3 className="w3-border-bottom w3-border-light-grey w3-padding-16">About</h3>
        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Excepteur sint
        occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco
        laboris nisi ut aliquip ex ea commodo consequat.
    </p>
      </div>

      <div className="w3-row-padding w3-grayscale">
        <div className="w3-col l3 m6 w3-margin-bottom">
          <img src={Appa} alt="John" style={{ width: '100%',height:'275px'  }} />
          <h3>KRISHNA MOORTHY</h3>
          <p className="w3-opacity">CEO & Founder</p>
          {/* <p>Phasellus eget enim eu lectus faucibus vestibulum. Suspendisse sodales pellentesque elementum.</p> */}
          <p><button className="w3-button w3-light-grey w3-block">Contact : 9443251713</button></p>
        </div>
        <div className="w3-col l3 m6 w3-margin-bottom">
          <img src={Ram} alt="Jane" style={{ width: '100%',height:'275px' }} />
          <h3>Ramasamy</h3>
          {/* <p className="w3-opacity">Architect</p> */}
          {/* <p>Phasellus eget enim eu lectus faucibus vestibulum. Suspendisse sodales pellentesque elementum.</p> */}
          <p><button className="w3-button w3-light-grey w3-block">Contact</button></p>
        </div>
        <div className="w3-col l3 m6 w3-margin-bottom">
          <img src={Raja} alt="Mike" style={{ width: '100%',height:'275px' }} />
          <h3>RAJA</h3>
          <p className="w3-opacity"></p>
          {/* <p>Phasellus eget enim eu lectus faucibus vestibulum. Suspendisse sodales pellentesque elementum.</p> */}
          <p><button className="w3-button w3-light-grey w3-block">Contact</button></p>
        </div>
        <div className="w3-col l3 m6 w3-margin-bottom">
          <img src={Kumar} alt="Dan" style={{ width: '100%',height:'275px' }} />
          <h3>KUMAR</h3>
          <p className="w3-opacity"> </p>
          {/* <p>Phasellus eget enim eu lectus faucibus vestibulum. Suspendisse sodales pellentesque elementum.</p> */}
          <p><button className="w3-button w3-light-grey w3-block">Contact</button></p>
        </div>
      </div>

      <footer class="w3-center w3-black w3-padding-16">
        <p>Powered by SRI MURUGAN HARDWARES</p>
      </footer>


    </React.Fragment>
  );




}